import { config } from '@/lib/config'

export const getDefaultTranslation = (names: any[]): string => {
	const name = names.find(n => n.lang === config.defaultLanguage)
	return name ? name.content : names[0]?.content
}

export const generateLangContent = (value: string, lang: string = config.defaultLanguage): ILangContent => ({
	lang: lang ?? config.defaultLanguage,
	content: value,
})

export const generateLangContentArray = (value: string, lang: string = config.defaultLanguage): ILangContent[] => [
	generateLangContent(value, lang),
]

export const LangContentToModel = (json: ILangContent[]): ILangContentModel =>
	// @ts-expect-error Model to have a better mapping of lang to content. PL is required.
	json.map(lg => ({ [lg.lang]: lg.content })).reduce((acc, curr) => ({ ...acc, ...curr }), {})

export const LangContentToJson = (
	model: ILangContentModel,
	updated?: string,
	languages: string[] = [config.defaultLanguage],
): ILangContent[] =>
	Object.entries(model).map(([lang, content]) => {
		if (!languages.includes(lang)) return { lang, content }

		return { lang, content: updated ?? content }
	})
